// extracted by mini-css-extract-plugin
module.exports = {"socialLoginContainer":"socialLogins_socialLoginContainer__dDCPc","socialBtns":"socialLogins_socialBtns__qTQfn"};